import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CoreTargetService {
  private selectedTarget: Record<string, any> = {};

  public setSelectedTarget(key: string, value: any): void {
    this.selectedTarget = {
      ...this.selectedTarget,
      [key]: value,
    };

    sessionStorage.setItem(key, value);
  }

  public getSelectedTarget(key: string): any {
    const selectedValue = this.selectedTarget?.[key];

    if (key == 'target' && !selectedValue && sessionStorage.getItem(key)) {
      return sessionStorage.getItem(key);
    }

    return this.selectedTarget?.[key];
  }
}
